module.exports = __webpack_public_path__ + "img/sf.e2104cd4.png";